import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'all_matches';

export const useAllMatchesTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => {
  return useTranslation('widgets', { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Все совпадения',
    show_more: 'Показать еще',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'All matches',
    show_more: 'Show more',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Todas las coincidencias',
    show_more: 'Mostrar más',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Todas as correspondências',
    show_more: 'Mostrar mais',
  },
}) : {}) as Record<string, unknown>;
